/**
 * Premium Cart Drawer polish hooks.
 * - Clears stale cart errors when the drawer opens (Dawn doesn't clear them on success).
 * - Listens for Shopify cart events (PubSub) and resets the error message.
 */
(function () {
  if (window.__pcdPolish) return;
  window.__pcdPolish = true;

  function clearErrors() {
    document.querySelectorAll('#CartDrawer-CartErrors, #cart-errors').forEach((el) => {
      el.textContent = '';
    });
    document.querySelectorAll('.cart-item__error-text').forEach((el) => {
      el.textContent = '';
    });
  }

  function init() {
    // Clear stale errors when drawer opens (Dawn toggles 'active' class)
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            if (drawer.classList.contains('active')) clearErrors();
          }
        }
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    // Also clear errors when the cart icon is clicked
    document.querySelectorAll('#cart-icon-bubble, [data-cart-trigger]').forEach((el) => {
      el.addEventListener('click', clearErrors, true);
    });

    // Listen for successful cart updates via Shopify's PubSub (Dawn fires on /cart/change success)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, clearErrors);
      } catch (e) { /* PUB_SUB_EVENTS.cartUpdate may not exist */ }
    }

    // Belt and suspenders — clear after 6s if it's still showing
    setInterval(() => {
      const errs = document.querySelectorAll('#CartDrawer-CartErrors, #cart-errors');
      errs.forEach((el) => {
        if (!el.textContent.trim()) return;
        if (!el.dataset.shownAt) {
          el.dataset.shownAt = Date.now().toString();
          return;
        }
        const age = Date.now() - parseInt(el.dataset.shownAt, 10);
        if (age > 6000) {
          el.textContent = '';
          delete el.dataset.shownAt;
        }
      });
    }, 1000);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
